//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    display: flex;
    flex-direction: column;
`;
export const Title = styled.h3`
    font-size: 16px;
    font-weight: 700;
    color: var(--light-gray-5);
    margin: 0;
    margin-bottom: 15px;
`;